// extracted by mini-css-extract-plugin
export var container = "_8p-0";
export var icon = "_8p-1";
export var text = "_8p-2";